// extracted by mini-css-extract-plugin
export default {"title":"OrderSummary_title__ru1O7","quote":"OrderSummary_quote__clFVt","ticketsList":"OrderSummary_ticketsList__gABnc","spinner":"OrderSummary_spinner__Pqm8+"};